import type { Directive } from 'vue'

// Desktop Chrome opens a time or date field's picker only from its small icon,
// so a click anywhere on the field opens it. Phones already do this; where
// showPicker is missing or refused, the field still takes typing.
function openPicker(event: MouseEvent) {
  const field = event.currentTarget
  if (!(field instanceof HTMLInputElement) || field.disabled || field.readOnly) return
  try {
    field.showPicker()
  } catch {
    // Unsupported, or not allowed from this click.
  }
}

/** v-open-picker: open a time or date input's native picker on any click. */
export const vOpenPicker: Directive<HTMLInputElement> = {
  mounted(el) {
    el.addEventListener('click', openPicker)
  },
  unmounted(el) {
    el.removeEventListener('click', openPicker)
  },
}
